import React, { useContext } from 'react'
import { PostPurchaseContext, PostPurchaseDispatchContext } from '../context/PostPurchaseContext';

function FormFileInput() {
    const state = useContext(PostPurchaseContext);
    const dispatch = useContext(PostPurchaseDispatchContext);

    function handleFileInput(e) {
        const file = e.target.files[0]
        const objectURL = window.URL.createObjectURL(file);
        dispatch({ type: 'setCustomerData', payload: { name: "proofOfPurchase", value: [{file, objectURL}] } })

        submitFileToS3(file)
    }

    async function submitFileToS3(file) {
        const base_url = 'https://briowater.com/apps/product-registration'
        const fileName = file.name
        const fileType = file.type
        const fileSize = String(file.size);
        const params = new URLSearchParams({
            signS3: "true",
            fileName,
            fileType,
            fileSize
        })
        const response = await fetch(`${base_url}?${params}`)
        const data = await response.json();
        const { url, signedRequest } = data;

        const putData = {
            method: "PUT",
            headers: {
                "Content-Type": fileType
            },
            body: file
        }
        const putResponse = await fetch(signedRequest, putData)
        if (putResponse.status === 200) {
            dispatch({ type: 'setCustomerData', payload: { name: "proofOfPurchaseUrl", value: url } })
        } else {
            alert('Problem with file upload. Please try again.')
        }
    }
    return (
        <label
            data-error-icon="!"
            data-error-msg="Attach proof of purchase."
            className="w-full cursor-pointer flex-1 relative after:z-10 after:absolute after:bottom-0 after:text-[#FD6F64] after:text-[12px] after:left-0 after:translate-y-full before:absolute before:right-2 before:top-1/2 before:bottom-1/2 before:w-[20px] before:h-[20px] before:rounded-full before:bg-[#FF7062] before:text-white before:content-none before:flex before:items-center before:justify-center"
        >
            <div className="uppercase font-normal">
                PROOF OF PURCHASE
            </div>
            <div className="bg-white shadow-[0_6px_12px_rgb(0_0_0_/_0.5)] rounded-2xl p-4 relative">
                <div className="gap-[12px] bottom-auto h-[88px] border-[1px] border-dashed rounded-3xl border-muted-400 border-opacity-50 flex items-center justify-center text-muted-400">
                    <div className="text-white bg-brio-800 rounded-full w-[28px] h-[28px] flex items-center justify-center text-5xl">+</div><div>Add Files</div>
                </div>
                <input
                    required
                    type="file"
                    accept="image/*,.pdf"
                    onChange={handleFileInput}
                    className="border absolute inset-0 border-dashed border-[#707070] rounded-xl w-[-webkit-fill-available] p-10 invisible"
                />
                {state.proofOfPurchase && state.proofOfPurchase.map(({ file, objectURL }) => {
                    // TODO: Replace imgSrc urls with real asset urls.
                    const imgSrc = file.type.startsWith('image/') ? 'image_icon.jpg' : 'pdf_icon.jpg'
                    return (
                    <div key={objectURL} className="flex items-center text-muted-400 mt-8">
                        <img className='max-w-[2rem] m-0' src="data:image/svg+xml,%3Csvg id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 22 27.6' style='enable-background:new 0 0 22 27.6;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23707070;stroke-linejoin:round;%7D .st1%7Bfill:none;stroke:%23707070;%7D .st2%7Bfill:none;%7D .st3%7Bfill:%23707070;%7D .st4%7Bfont-family:'CentraNo2-Medium';%7D .st5%7Bfont-size:7px;%7D
%3C/style%3E%3Cg id='Group_14617' transform='translate(0.353 0.5)'%3E%3Cpath id='Path_1725' class='st0' d='M0.1,0h15.5l5.5,5.5v21.1h-21V0z'/%3E%3Cpath id='Path_1726' class='st1' d='M21.1,18.3h-21'/%3E%3Cg id='Ellipse_72' transform='translate(2.606 5.138)'%3E%3Ccircle class='st2' cx='3' cy='3' r='3'/%3E%3Ccircle class='st1' cx='3' cy='3' r='2.5'/%3E%3C/g%3E%3Cpath id='Path_1727' class='st0' d='M14.8,0v6.3h6.4'/%3E%3Cpath id='Path_1728' class='st0' d='M14.3,18.3l-6.1-6.7L0,18.3'/%3E%3Cpath id='Path_1729' class='st1' d='M10.5,14.2l5.9-5.1l4.8,4.2'/%3E%3Ctext transform='matrix(1 0 0 1 3.606 25.138)' class='st3 st4 st5'%3EJPG%3C/text%3E%3C/g%3E%3C/svg%3E" />
                        <div className="ml-[14px]">{file.name}</div>
                        <div className="ml-auto h-[19px] min-w-[19px] border-[1px] flex items-center justify-center border-brio-400 rounded-full">✓</div>
                        </div>)
                })}
            </div>
        </label>
    )
}

export default FormFileInput